<template>
  <div id="lista-hoteli">
    <T1HeadScripts rodzajstrony="listahoteli" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content>
          <T1ListaHoteliContent />
        </a-layout-content>
      </div>
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1ListaHoteliContent from "./components/T1ListaHoteliContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "lista-hoteli",
  data: () => ({}),
  methods: {},
  mounted() {},
  components: {
    T1HeadScripts,
    T1Header,
    T1ListaHoteliContent,
    T1Footer
  }
};
</script>
